const DEFAULT_JCQ_ALLOWLIST_EMAILS = [
  'wf@classlabs.co.uk',
  'sam@classlabs.co.uk',
  'main@classlabs.co.uk'
];

const parseEmails = (value = '') => String(value || '')
  .split(',')
  .map((email) => email.trim().toLowerCase())
  .filter(Boolean);

const JCQ_ALLOWLIST_EMAILS = new Set([
  ...DEFAULT_JCQ_ALLOWLIST_EMAILS,
  ...parseEmails(process.env.REACT_APP_JCQ_ALLOWLIST_EMAILS)
]);

// JCQ decommissioned for now (15 Oct 2026): pages hidden and the backend /api/jcq routes disabled.
// Set to true (and re-mount the backend router) to bring it back.
const JCQ_ENABLED = false;

export const canAccessJcq = (user = {}) => {
  if (!JCQ_ENABLED) return false;
  const email = String(user?.email || user?.user?.email || user?.data?.email || '').trim().toLowerCase();
  return Boolean(email && JCQ_ALLOWLIST_EMAILS.has(email));
};

export const getJcqAllowlistEmails = () => Array.from(JCQ_ALLOWLIST_EMAILS);
